import { AppPageComponent } from '../../shared/ui';
import { Component, OnInit, ViewChild} from '@angular/core';
import { LocationSaleService, LocationsFilterSheetComponent, LocationsFilter, LocationSale} from '../shared';
import { DateRange, HeaderAction, TopLevelComponent } from '../../shared';
import { FormGroup } from '@angular/forms';
import {
    Store,
    StoreHelper,
    UserService,
} from '../../shared/services';

@Component({
    template: require('./location-index.component.pug')
})

export class LocationIndexComponent extends TopLevelComponent implements OnInit {
    @ViewChild(AppPageComponent) appPage;
    @ViewChild(LocationsFilterSheetComponent) filterSheet;

    fg = new FormGroup({});

    private locationinvoiceOpen: Array<LocationSale>;
    private locationinvoiceClosed: Array<LocationSale>;
    private _searchAction = { id: 'calendar', icon: 'calendar' };
    private _locationFilter: LocationsFilter;
    private _filterReady: boolean = false;
    private rangeDate = new DateRange();
    private filterByName: string;
    
    empty = false;
    loading = true;
    authorized = true;


    constructor(
        private locationSaleService: LocationSaleService,
        store: Store,
        storeHelper: StoreHelper,
        userService: UserService
    ) {
        super(store, storeHelper, userService);

        // set title and actions
        this.headerTitle = 'Locations';
        this.headerActions = [this._searchAction];
        this.subscribeToHeaderActions(this._reactToHeaderAction);
    }

    ngOnInit() {
        this.appPage.activatePreloader();
    }


    onFilterChanged(filter: LocationsFilter) {
        this._locationFilter = filter;
        this._loadLocationSaleList();
    }

    private _reactToHeaderAction(action: HeaderAction) {
        if (action.id === this._searchAction.id && this.authorized) {
            this.filterSheet.toggle();
        }
    }

    private _loadLocationSaleList() {

        let that = this;

        this._FilterLocationListByName();

        if (this._locationFilter.locationsSelection.locations.length < 1) {
            this._resetLocationSales();
            this.empty = true;
            if (this.empty) {
                setTimeout(() => this.filterSheet.toggle(), 1500);
            }

            if (this._filterReady) {
                this.filterSheet.toggle();
            }

            this._filterReady = true;

            return;
        }

        this.loading = true;
        this.locationSaleService.getLocationSales(this._locationFilter)
            .subscribe(locations => {
                this.empty = locations.length <= 0;
                this.locationinvoiceOpen = locations.filter(l => l.open === true);
                this.locationinvoiceClosed = locations.filter(l => l.open === false);

                if (this.empty) {
                    setTimeout(() => this.filterSheet.toggle(), 1500);
                }

                if (this._filterReady) {
                    this.filterSheet.toggle();
                }

                this._filterReady = true;
                that.appPage.deactivatePreloader();
            }, 
            err => {
                this.authorized = this.userService.userHasAccess(err);
                this.appPage.deactivatePreloader();
                this.loading = false;
                this._resetLocationSales();
            },
            () => that.loading = false);
    }

    private _FilterLocationListByName() {

        this.filterByName = this._locationFilter.filter.toLowerCase() || '';

        if (this._locationFilter.locationsSelection.locations.length > 0) {

            this._locationFilter.locationsSelection.locations = this.filterByName !== ''
                ? this._locationFilter.locationsSelection.locations.filter(l => l.name.toLowerCase().indexOf(this.filterByName) !== -1)
                : this._locationFilter.locationsSelection.locations;
        }
        else {
            this._UpdateLocationsByRegion();
        }
    }

    private _UpdateLocationsByRegion() {
        this._locationFilter.locationsSelection.locations = this.filterByName !== ''
            ? this._locationFilter.locationsSelection.region.locations.filter(l => l.name.toLowerCase().indexOf(this.filterByName) !== -1)
            : this._locationFilter.locationsSelection.region.locations;
    }

    private _resetLocationSales() {
        this.locationinvoiceOpen = [];
        this.locationinvoiceClosed = [];
    }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/tslint-loader!./src/app/location/location/location-index.component.ts